<template>
    <div style="margin: 10px">
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <v-form>
                <v-layout wrap>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                        <v-select :label="$t('lang.area.name')"
                                  v-model.trim="search.areaId"
                                  v-validate="'required'"
                                  :items="lstArea"
                                  item-text="categoryCode"
                                  item-value="categoryId"
                                  @change="onSearch"
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                        <v-btn color="primary" dark @click="onSearch">
                            <v-icon dark left>search</v-icon>
                            {{$t('lang.common.search')}}
                        </v-btn>
                        <v-btn color="info" @click="editItem" v-if="search.areaId != null && !isEdit">
                            <v-icon dark left>edit</v-icon>
                            {{ $t("lang.common.edit") }}
                        </v-btn>
                        <v-btn color="info" @click="showHistory" v-if="createItem.gIndexId != null && !isEdit">
                            <v-icon dark left>mdi-history</v-icon>
                            {{ $t("lang.common.history") }}
                        </v-btn>

                    </v-flex>
                </v-layout>
                <v-card-text>
                    <table class="lstTable" v-if="search.areaId != null">
                        <tr>
                            <th width="10%" rowspan=3>STT</th>
                            <th width="20%" rowspan=3>Chỉ số</th>
                            <th width="10%" rowspan=3>Đơn vị</th>
                            <th width="60%" colspan=5>G</th>
                        </tr>
                        <tr>
                            <th width="30%" colspan=2>G1</th>
                            <th width="30%" colspan=2>G2</th>
                        </tr>
                        <tr>
                            <th width="15%">Min</th>
                            <th width="15%">Max</th>
                            <th width="15%">Khoảng 1</th>
                            <th width="15%">Khoảng 2</th>
                        </tr>
                        <tr v-for="(envIdx,idx) in lstIndex">
                            <td style="text-align: center">{{idx+1}}</td>
                            <td>{{envIdx.envName}}</td>
                            <td>{{envIdx.unitType}}</td>
                            <td style="text-align: right">
                                <input type="number" v-model="createItem.g1Index[envIdx.envId].min" v-if="isEdit"
                                       :data-index="idx"
                                       data-session="min"
                                       :id="'min_'+idx" @keydown="keyProcess"
                                       @change="updateForm"/>
                                <template v-else>
                                    {{createItem.g1Index[envIdx.envId].min}}
                                </template>
                            </td>
                            <td style="text-align: right">
                                <input type="number" v-model="createItem.g1Index[envIdx.envId].max" v-if="isEdit"
                                       :data-index="idx"
                                       data-session="max"
                                       :id="'max_'+idx" @keydown="keyProcess"
                                       @change="updateForm"/>
                                <template v-else>
                                    {{createItem.g1Index[envIdx.envId].max}}
                                </template>
                            </td>
                            <td style="text-align: right">
                                {{getRange1(createItem.g2Index[envIdx.envId])}}
                            </td>
                            <td style="text-align: right">
                                {{getRange2(createItem.g2Index[envIdx.envId])}}
                            </td>
                        </tr>
                    </table>
                    <div style="text-align: right" v-if="isEdit">
                        <v-btn color="primary" @click="onSave">
                            <v-icon dark left>save</v-icon>
                            {{ $t("lang.common.save") }}
                        </v-btn>
                        <v-btn color="error" @click="onCancel">
                            <v-icon dark left>cancel</v-icon>
                            {{ $t("lang.common.cancel") }}
                        </v-btn>
                    </div>
                </v-card-text>
            </v-form>
        </v-card>
        <feature-log ref="featureDlg"/>
    </div>
</template>

<script>
    import axios from "axios";
    import IDatepicker from "../../../components/form/DatePicker";
    import {message} from "../../../shared/message";
    import FeatureLog from "../FeatureLog";

    export default {
        name: "g-index",
        components: {FeatureLog, IDatepicker},
        data: () => {
            return {
                formName: "Chỉ số môi trường",
                isEdit: false,
                lstIndex: [],
                lstPond: [],
                lstArea: [],
                lstCrop: [],
                lstCropCreate: [],
                lstItem: [],
                search: {},
                createItem: {
                    pondId: null,
                    areaId: null,
                    g1: null,
                    g2: null,
                    g1Idx: {},
                    g2Idx: {},
                },
                totalRows: 0,
                pagination: {
                    rowsPerPage: 10,
                    page: 1,
                    totalItems: 0
                },
            };
        },

        created() {
            this.getEnvIndex();
            this.getArea();
        },

        methods: {
            keyProcess($event) {
                const inputs = Array.from($event.target.form.querySelectorAll('input[type="number"]'));
                const index = inputs.indexOf($event.target);
                let idx = parseInt($event.target.getAttribute("data-index"));
                let session = $event.target.getAttribute("data-session");
                switch ($event.keyCode) {
                    case 37:
                        // left
                        if (index > 0) {
                            inputs[index - 1].focus();
                        }
                        $event.preventDefault();
                        break;
                    case 38:
                        // up
                        if (idx > 0) {
                            let id = session + "_" + (idx - 1);
                            console.log(id);
                            document.getElementById(id).focus();
                            console.log(id);
                        }
                        $event.preventDefault();
                        break;
                    case 13:
                    case 39:
                        //right
                        if (index < inputs.length - 1) {
                            inputs[index + 1].focus();
                        }
                        $event.preventDefault();
                        break;
                    case 40:
                        //down
                        if (idx < this.lstIndex.length - 1) {
                            let id = session + "_" + (idx + 1);
                            document.getElementById(id).focus();
                        }
                        $event.preventDefault();
                        break;
                }

            },

            isNumber(num) {
                if (num == undefined || num == null || num == "") {
                    return false;
                }
                return !isNaN(num);
            },

            getRange1(g2) {
                if (g2.min1 && g2.max1) {
                    return g2.min1 + "-" + g2.max1;
                } else {
                    return "";
                }

            },

            getRange2(g2) {
                if (g2.min2 && g2.max2) {
                    return g2.min2 + "-" + g2.max2;
                } else {
                    return "";
                }
            },

            getEnvIndex() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/envIndex/search?pageSize=-1&page=0", {}
                ).then(
                    (data) => {
                        this.lstIndex = data.items;
                    }
                );
            },

            getArea() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/myArea"
                ).then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstArea = data;
                        }
                    }
                );
            },

            getCropSearchList() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1&orderBy=asc", {pondAreaId: this.search.areaId}
                ).then(
                    (data) => {
                        if (data.items) {
                            this.lstCrop = data.items;
                            this.lstCropCreate = data.items;
                        }
                    }
                );

            },

            updateForm() {
                for (let i = 0; i < this.lstIndex.length; i++) {
                    if (this.createItem.g1Index[this.lstIndex[i].envId] == undefined || this.createItem.g1Index[this.lstIndex[i].envId] == null) {
                        this.createItem.g1Index[this.lstIndex[i].envId] = {};
                    }
                    if (this.createItem.g2Index[this.lstIndex[i].envId] == undefined || this.createItem.g2Index[this.lstIndex[i].envId] == null) {
                        this.createItem.g2Index[this.lstIndex[i].envId] = {};
                    }
                    let min = this.createItem.g1Index[this.lstIndex[i].envId].min;
                    let max = this.createItem.g1Index[this.lstIndex[i].envId].max;

                    console.log(min + "-" + this.isNumber(min));
                    console.log(max + "-" + this.isNumber(max));
                    if (!this.isNumber(min)) {
                        this.createItem.g2Index[this.lstIndex[i].envId].min1 = null;
                        this.createItem.g2Index[this.lstIndex[i].envId].max1 = null;
                    } else {
                        min = parseFloat(min);
                        if (this.isNumber(min)) {
                            let min1 = (min * 0.8);
                            let max1 = (min - 0.1);
                            console.log("before:" + min1 + "-" + max1);
                            if (min1 > max1) {
                                let temp = max1;
                                max1 = min1;
                                min1 = temp;
                            }
                            console.log("after:" + min1 + "-" + max1);
                            min1 = min1.toFixed(2);
                            max1 = max1.toFixed(2);
                            this.createItem.g2Index[this.lstIndex[i].envId].min1 = min1;
                            this.createItem.g2Index[this.lstIndex[i].envId].max1 = max1;
                        }
                    }
                    if (!this.isNumber(max)) {
                        this.createItem.g2Index[this.lstIndex[i].envId].min2 = null;
                        this.createItem.g2Index[this.lstIndex[i].envId].max2 = null;

                    } else {
                        max = parseFloat(max);
                        if (this.isNumber(max)) {
                            let min2 = (max + 0.1);
                            let max2 = (max * 1.2);
                            if (min2 > max2) {
                                let temp = max2;
                                max2 = min2;
                                min2 = temp;
                            }
                            min2 = min2.toFixed(2);
                            max2 = max2.toFixed(2);
                            this.createItem.g2Index[this.lstIndex[i].envId].min2 = min2;
                            this.createItem.g2Index[this.lstIndex[i].envId].max2 = max2;
                        }
                    }
                    if (min != null && min != undefined && min != "" && max != null && max != undefined && max != "") {
                        if (min > max) {
                            message.error("Min phải nhỏ hơn Max");
                        }
                    }

                }
                this.$forceUpdate();
            },

            onSearch() {
                this.isEdit = false;
                if (this.search.areaId == undefined || this.search.areaId == null) {
                    message.error("Chưa chọn khu");
                    return;
                }
                axios.post(
                    process.env.VUE_APP_API_URL + "/gindex/search", this.search
                ).then(
                    (data) => {
                        if (data.items && data.items.length > 0) {
                            this.createItem = data.items[0];
                            if (this.createItem.g1 != undefined && this.createItem.g1 != null) {
                                this.createItem.g1Index = JSON.parse(this.createItem.g1);
                            } else {
                                this.createItem.g1Index = {};
                            }

                            if (this.createItem.g2 != undefined && this.createItem.g2 != null) {
                                this.createItem.g2Index = JSON.parse(this.createItem.g2);
                            } else {
                                this.createItem.g2Index = {};
                            }
                            //
                            //
                            //
                            for (let i = 0; i < this.lstIndex.length; i++) {
                                if (this.createItem.g1Index[this.lstIndex[i].envId] == undefined || this.createItem.g1Index[this.lstIndex[i].envId] == null) {
                                    this.createItem.g1Index[this.lstIndex[i].envId] = {};
                                }
                                if (this.createItem.g2Index[this.lstIndex[i].envId] == undefined || this.createItem.g2Index[this.lstIndex[i].envId] == null) {
                                    this.createItem.g2Index[this.lstIndex[i].envId] = {};
                                }
                            }


                        } else {
                            this.createNew();
                        }
                    }
                );
            },

            createNew() {
                this.createItem = {
                    areaId: this.search.areaId,
                    pondId: this.search.pondId,
                    g1: null,
                    g2: null,
                    g1Index: {},
                    g2Index: {},
                    notes: null
                };
                for (let i = 0; i < this.lstIndex.length; i++) {
                    this.createItem.g1Index[this.lstIndex[i].envId] = {};
                    this.createItem.g2Index[this.lstIndex[i].envId] = {};
                }
                console.log(this.createItem);

            },

            onCancel() {
                this.isEdit = false;
                this.onSearch();
            },
            onSave() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        for (let i = 0; i < this.lstIndex.length; i++) {
                            let min = parseFloat(this.createItem.g1Index[this.lstIndex[i].envId].min);
                            let max = parseFloat(this.createItem.g1Index[this.lstIndex[i].envId].max);
                            if (min > max) {
                                message.error("Dòng " + (i + 1) + " Min lớn hơn Max");
                                return;
                            }
                        }

                        this.createItem.g1 = JSON.stringify(this.createItem.g1Index);
                        this.createItem.g2 = JSON.stringify(this.createItem.g2Index);
                        axios.post(process.env.VUE_APP_API_URL + "/gindex/save", this.createItem).then(
                            data => {
                                if (data.success) {
                                    message.success(this.$t("lang.common.save_success"));
                                    this.onCancel();
                                } else {
                                    message.error(data.description);
                                }
                            }
                        )
                    } else {
                        message.error("Thông tin nhập chưa chính xác")
                    }
                })

            },
            editItem() {
                this.isEdit = true;
            },
            deleteItem(item) {
                if (confirm(this.$t("lang.common.deleteConfirm"))) {
                    axios.post(process.env.VUE_APP_API_URL + "/envMeasure/delete", item).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.delete_success"));
                                this.onSearch();
                            } else {
                                message.error("Xóa không thành công")
                            }
                        }
                    )

                }
            },

            showHistory(){
                this.$refs.featureDlg.onSearch("GIndex",this.createItem.gIndexId);
            }
        },

        destroyed() {
        },
    };
</script>
